
import React, { Fragment } from "react";
import ReportIcon from "root/Reporting/ReportIcon";
import IconElement from "root/Reporting/IconElement";

const ReportPanel = ( { image, title, color, links }) =>
{
    const notBlank = ( text ) =>
    {
        return  text === null ? '&nbsp;' : text ;
    }

    const row = ( data ) =>
    {
        if ( data.onClick !== undefined )
        {
            return (
                <div key={data.keyName} className='report-link'>
                    <div>
                        <IconElement iconName={data.icon} />
                    </div>
                    <div>
                        <div onClick={data.onClick} style={{cursor: 'pointer'}} dangerouslySetInnerHTML={{__html: notBlank(data.text)}}/>
                    </div>
                </div>
            )
        }
        else if ( data.openAsNewTab === true )
        {
            return (
                <div key={data.keyName} className='report-link'>
                    <div >
                        <IconElement iconName={data.icon} />
                    </div>
                    <div>
                        <a href={data.link} target="_blank" dangerouslySetInnerHTML={{__html: notBlank(data.text)}}/>
                    </div>
                </div>
            )
        }
        else
        {
            return (
                <div key={data.keyName} className='report-link'>
                    <div>
                        <i className={data.icon}/>
                    </div>
                    <div>
                        <a href={data.link} dangerouslySetInnerHTML={{__html: notBlank(data.text)}}/>
                    </div>
                    <div>
                        {/*pdfLink(data)*/}
                    </div>
                </div>
            )
        }
    }
    const renderLinks = () =>
    {
        return links.map ((item,index) => row(item)) ;
    }

return (
    <div className='report-content-row'style={{borderTop:'10px solid ' + color}}>
        <div className='report-content-row-header'><ReportIcon image={image}/><h4>{ title }</h4></div>
        <div >
            {renderLinks()}
        </div>
    </div>

)
}

export default ReportPanel ;